export const SET_LOADER = "SET_LOADER";
export const SET_LOADER_TYPE = "SET_LOADER_TYPE";
export const SET_FORM_FLAG = "SET_FORM_FLAG";
export const SET_TAB_DETAIL = "SET_TAB_DETAIL";
export const SET_FILTER_BY_DATA = "SET_FILTER_BY_DATA";
export const SET_TABLE_FILTER_OPTION = "SET_TABLE_FILTER_OPTION";
export const SET_TABLE_FORM_DATA = "SET_TABLE_FORM_DATA";
export const SET_REFRIGERANT_TABLE_DATA = "SET_REFRIGERANT_TABLE_DATA";
export const SET_REFRIGERANT_TABLE_TOTAL = "SET_REFRIGERANT_TABLE_TOTAL";
export const SET_BUILDING_DETAILS = "SET_BUILDING_DETAILS";
export const SET_BUILDING_HISTORY = "SET_BUILDING_HISTORY";
export const SET_EQUIPMENT_DETAILS = "SET_EQUIPMENT_DETAILS";
export const SET_EQUIPMENT_HISTORY = "SET_EQUIPMENT_HISTORY";
export const SET_EQUIPMENT_COUNT_DATA = "SET_EQUIPMENT_COUNT_DATA";
export const SET_BRAND_EQUIPMENT_DATA = "SET_BRAND_EQUIPMENT_DATA";
export const SET_BRAND_DETAILS_DATA = "SET_BRAND_DETAILS_DATA";
export const RESET_DATA = "RESET_DATA";
export const RESET_FORM_TABLE_DATA = "RESET_FORM_TABLE_DATA";
export const SET_CARD_LOADER = "SET_CARD_LOADER";